module.exports = __webpack_public_path__ + "static/Sample-3-78f0ba9712bff6064a300208de090efd.png";